import React, { Component } from "react";
import { languages } from "../../constants/languages";
import EditDayDialog from "../../components/schedule/EditDayDialog";
import moment from "moment-timezone";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import Typography from "@material-ui/core/Typography";
import CreateIcon from "@material-ui/icons/Create";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import { generateSearchRecords } from "../../util/GenerateSearchRecords";

class EditDayContainer extends Component {
  state = {
    open: false,
    date: moment().tz(
      this.props.timezone ||
        this.props.tournament.timezone ||
        "Europe/Amsterdam"
    ),
    errorMessage: "",
  };

  toggleDialog = (e) => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  UNSAFE_componentWillMount = () => {
    const day = this.props.day;
    if (day) {
      this.updateState(day);
    } else {
      let lastDay = { date: this.props.tournament.date + 24 * 60 * 60 };
      if (this.props.days.length > 0) {
        lastDay = this.props.days[this.props.days.length - 1];
        if (lastDay) {
          lastDay = { date: lastDay.date + 24 * 60 * 60 };
        }
      }
      if (lastDay) {
        this.updateState(lastDay);
      }
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const day = nextProps.day;
    if (day) {
      this.updateState(day);
    } else {
      let lastDay = { date: nextProps.tournament.date + 24 * 60 * 60 };
      if (nextProps.days.length > 0) {
        lastDay = nextProps.days[nextProps.days.length - 1];
        if (lastDay) {
          lastDay = { date: lastDay.date + 24 * 60 * 60 };
        }
      }
      if (lastDay) {
        this.updateState(lastDay);
      }
    }
  };

  updateState = (day) => {
    this.setState({
      date: moment
        .unix(day.date)
        .tz(
          this.props.timezone ||
            this.props.tournament.timezone ||
            "Europe/Amsterdam"
        ),
    });
  };

  handleDateChange = (date) => {
    this.setState({
      date: date.tz(
        this.props.timezone ||
          this.props.tournament.timezone ||
          "Europe/Amsterdam"
      ),
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.toggleDialog(e);
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let date = this.state.date
      .tz(
        this.props.timezone ||
          this.props.tournament.timezone ||
          "Europe/Amsterdam"
      )
      .unix();

    let dayDoc = tournamentRef.collection("days").doc();
    if (this.props.day && !this.props.firstDay) {
      dayDoc = tournamentRef.collection("days").doc(this.props.day.id);
    }

    const db = window.firebase.firestore();
    let batch = db.batch();
    if (this.props.tournament.ia) {
      if (!this.props.tournament.online) {
        Object.keys(this.props.tournament.fields || {}).forEach((fieldKey) => {
          batch.set(db.collection("cacheUpdatesForField").doc(), {
            tournamentId: this.props.tournament[".key"],
            fieldId: fieldKey,
            status: "pending",
            timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
          });
        });
      }
    }
    if (this.props.firstDay) {
      batch.update(tournamentRef, { date: date });
      if (this.props.tournament.ia) {
        batch = generateSearchRecords(
          {
            id: this.props.tournament[".key"],
            name: this.props.tournament.name,
            date: date,
            bgURL: this.props.tournament.bgURL,
            logoURL: this.props.tournament.logoURL,
          },
          batch
        );
      }
    } else {
      batch.set(dayDoc, { date: date });
    }
    batch.commit();

    if (this.props.tournament.ia) {
      window.firebase.firestore().collection("cacheUpdatesApp").doc().set({
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    }
  };

  handleDelete = (e) => {
    e.preventDefault();
    if (
      this.props.matches.filter((match) => match.day === this.props.day.id)
        .length > 0
    ) {
      this.setState({ errorMessage: languages.schedule.cannotDeleteDay });
    } else {
      this.toggleDialog(e);
      if (this.props.day.id === this.props.selectedDay) {
        this.props.selectDay("0");
      }
      const db = window.firebase.firestore();
      let batch = db.batch();
      const tournamentRef = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);
      batch.delete(tournamentRef.collection("days").doc(this.props.day.id));
      if (this.props.tournament.ia) {
        batch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }
      batch.commit();
    }
  };

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  render() {
    return (
      <div>
        {this.props.day ? (
          this.props.new ? (
            <TextField
              style={{ marginTop: 10, marginBottom: 5 }}
              onClick={this.toggleDialog}
              value={moment
                .unix(this.props.day.date)
                .tz(
                  this.props.timezone ||
                    this.props.tournament.timezone ||
                    "Europe/Amsterdam"
                )
                .format(languages.createTournament.dateFormat)}
              fullWidth
              label={languages.schedule.day + " " + this.props.num}
            />
          ) : (
            // <ExpansionPanel
            //   expanded={false}
            //   style={{
            //     width: "100%",
            //     margin: "1px 0px 1px 0px"
            //   }}
            // >
            //   <ExpansionPanelSummary
            //     IconButtonProps={{
            //       onClick: this.toggleDialog,
            //       disabled: this.props.tournament.nvdCode !== undefined
            //     }}
            //     expandIcon={<CreateIcon />}
            //     style={{ cursor: "default" }}
            //   >
            //     <Typography
            //       variant="body2"
            //       style={{
            //         flexBasis: "33.33%",
            //         flexShrink: 0,
            //         color: "rgba(0, 0, 0, 0.54)"
            //       }}
            //     >
            //       {languages.schedule.day + " " + this.props.num}
            //     </Typography>
            //     <Typography variant="body2">
            //       {moment
            //         .unix(this.props.day.date)
            //         .format(languages.createTournament.dateFormat)}
            //     </Typography>
            //   </ExpansionPanelSummary>
            // </ExpansionPanel>

            <Card style={{ marginBottom: 1 }}>
              <CardHeader
                style={{ padding: "5px 15px" }}
                avatar={
                  <Avatar
                    variant="rounded"
                    aria-label="number"
                    style={{ fontWeight: 500 }}
                  >
                    {this.props.num}
                  </Avatar>
                }
                action={
                  <IconButton
                    aria-label="edit"
                    onClick={this.toggleDialog}
                    disabled={this.props.tournament.nvdCode !== undefined}
                    style={{ marginTop: 8 }}
                  >
                    <CreateIcon />
                  </IconButton>
                }
                title={this.capitalizeFirstLetter(
                  moment
                    .unix(this.props.day.date)
                    .tz(
                      this.props.timezone ||
                        this.props.tournament.timezone ||
                        "Europe/Amsterdam"
                    )
                    .format(languages.general.dateFormat)
                )}
                subheader={""}
              />
            </Card>
          )
        ) : this.props.new ? (
          <Button
            style={{ marginTop: 10 }}
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
          >
            {languages.createTournament.addDate}
          </Button>
        ) : (
          <Button
            style={{ height: 48 }}
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
            fullWidth
          >
            {languages.schedule.addDay}
          </Button>
        )}
        <EditDayDialog
          date={this.state.date}
          open={this.state.open}
          day={this.props.day}
          firstDay={this.props.firstDay}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleDateChange}
          handleSubmit={this.handleSubmit}
          handleDelete={this.handleDelete}
          errorMessage={this.state.errorMessage}
        />
      </div>
    );
  }
}

export default EditDayContainer;
